import React from 'react'
import { Spinner } from 'react-bootstrap'
import styled, { css } from 'styled-components'
import { useWindowDimensions } from 'hooks'
import { $gray_700 } from 'utils/colors'
import { scaleSidebar } from './layout/Layout'

const S = {
    FullPageLoading: styled.div<Props>`
        width: 100%;
        height: 100vh;
        padding-bottom: 58px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        ${({ isAbsolute }) => isAbsolute && css<Props>`
            position: fixed;
            top: 0;
            left: ${({ fullWidth, screenWidth }) => (fullWidth ? 0 : scaleSidebar(screenWidth))}px;
            width: ${({ fullWidth }) => (fullWidth ? '100%' : 'calc(100% - 250px)')};
            z-index: 1111;
            background: ${({ transparentBackground }) => (transparentBackground ? 'transparent' : 'rgba(0, 0, 0, 0.2)')};
        }
        `}
    `,
    LoadingIndicator: styled(Spinner)`
        width: 80px;
        height: 80px;
    `,
    Text: styled.p`
        margin-top: 10px;
        color: ${$gray_700};
    `,
}

interface Props {
    text?: string
    isAbsolute?: boolean
    fullWidth?: boolean
    transparentBackground?: boolean
    screenWidth?: number
    className?: string
}

const FullPageLoading = ({
    text, isAbsolute, fullWidth, transparentBackground, className
}: Props) => {
    const { width: screenWidth } = useWindowDimensions()
    return (
        <S.FullPageLoading
            className={className}
            isAbsolute={isAbsolute}
            fullWidth={fullWidth}
            screenWidth={screenWidth}
            transparentBackground={transparentBackground}
        >
            <S.LoadingIndicator animation="border" role="status" variant="secondary" />
            {text && <S.Text>{text}</S.Text>}
        </S.FullPageLoading>
    )
}

export default FullPageLoading
